import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiServer } from "../../helpers/Api_help";

const API_BASE = `${ApiServer}manage-booking-user/`;

 export const fetchUserTicketLimit = createAsyncThunk(
  "freeEvent/fetchUserTicketLimit",
  async ({ userId, eventId }, { rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${API_BASE}free-event-ticket-limit/${userId}/${eventId}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);



 const freeEventSlice = createSlice({
  name: "freeEvent",
  initialState: {
    ticketLimit: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserTicketLimit.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserTicketLimit.fulfilled, (state, action) => {
        state.loading = false;
        state.ticketLimit = action.payload;
      })
      .addCase(fetchUserTicketLimit.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default freeEventSlice.reducer;
